import { useSearchParams } from "react-router-dom";
import { Breadcrumb } from "@/components/ui/breadcrumb";
import { PageHeader } from "@/components/data-display/page-header";
import { WipHint } from "@/components/ui/wip-hint";
import { PolicyAuthoringWip, resolvePolicyAuthoringWipStep } from "@/features/oversight/policy-authoring-wip";

/**
 * `/governance/new` — Create Policy, designed layout over a missing backend
 * (design-port round 2026-10-03, flow G10; ALL-5825).
 *
 * The route is registered before `/governance/:id` in App.tsx so the static
 * segment wins. The prototype's `PolicyAuthoringFlow` reads a policy store and
 * creates a policy; policy definitions have no backend route in this
 * environment (page-delivery-pipeline.md G2 `defer`), so the page is layout
 * only: it renders the four-step wizard shell with every control disabled and
 * no value from the prototype's fixtures. The step shown is taken from the
 * `?step=` query so the designed panels are addressable without any mutation.
 */
export default function GovernanceNewPage() {
  const [params] = useSearchParams();
  const step = resolvePolicyAuthoringWipStep(params.get("step"));

  return (
    <div className="max-w-[900px]">
      <Breadcrumb items={[{ label: "Governance", href: "/governance" }, { label: "Policy Authoring" }]} />
      <PageHeader
        title="Create Policy"
        subtitle="Policies are evaluated against every transfer intent before it can be signed."
        actions={<WipHint />}
      />

      <PolicyAuthoringWip step={step} />
    </div>
  );
}
